import React, { useState, useEffect, useRef } from "react";
import { useAppDispatch, useAppSelector } from ".";
import {
  getBrightspeedToken,
  setHeaders,
} from "../SharedContextStore/slices/brightspeedToken";
import { getSessionId } from "../SharedContextStore/slices/user";
import { webRefreshTokenRedux } from "../../../shared/utils/Constants";
import store from "../SharedContextStore/store";

export default function useBrightspeedHeaders() {
  const dispatch = useAppDispatch();
  const headers = useAppSelector((state) => state?.brightspeedToken?.headers);
  const globalToken = useAppSelector((state) => state?.brightspeedToken?.data);
  const sessionId = useAppSelector((state) => state?.user?.sessionId);
  const refreshToken = useAppSelector((state) => state?.user?.refreshToken);
  // const accessToken = useAppSelector (state=> state.tokenData?.globalToken)

  const brightSpeedFiberIndicator = useAppSelector(
    (state) =>
      state?.addressQualification?.data?.addressQualification?.entity
        ?.brightSpeedFiberIndicator
  );
  const hasFetched=useRef(false)
  const AddressQualificationSiteId = useAppSelector(
    (state) =>
      state?.addressQualification?.data?.addressQualification?.entity?.siteId
  );
  const instantInternet = useAppSelector(
    (state) =>
      state?.addressQualification?.data?.addressQualification?.entity
        ?.instantInternet
  );

  const user = useAppSelector((state) => state.user.data);

  // useEffect(()=>{
  //     if(user?.billingSystem && user?.networkType && !headers?.billingSystem && !headers?.networkType){
  //       dispatch(
  //         setHeaders({
  //           ...headers,
  //           billingType: user?.billingType,
  //           billingSystem: user?.billingSystem,
  //           networkType: user?.networkType
  //         })
  //       );
  //     }

  // },[user])



  useEffect(() => {
    if (
      !globalToken?.access_token &&
      process.env.REACT_APP_ENV === "production" &&
      !headers?.Authorization
    ) {
      const source = {
        refreshToken: async () => await dispatch(getBrightspeedToken()),
        webReduxStore: store,
      };
      Object.assign(webRefreshTokenRedux, source);
      getBrightspeedTokenSync();
    }
  }, []);

  useEffect(() => {
    if (
      !sessionStorage?.getItem("sessionId") &&
      ((process.env.REACT_APP_ENV === "production" && headers?.Authorization && !hasFetched.current) ||
      (process.env.REACT_APP_ENV !== "production" && !hasFetched.current))
    ){
      hasFetched.current=true
      dispatch(getSessionId());
    }
  }, [globalToken]);

  useEffect(() => {
    if (globalToken?.access_token && !headers?.Authorization) {
      dispatch(
        setHeaders({
          ...headers,
          Authorization: `Bearer ${globalToken?.access_token}`,
        })
      );
    }
  }, [globalToken]);

  useEffect(() => {
    if (sessionId && headers?.sessionId !== sessionId) {
      dispatch(
        setHeaders({
          ...headers,
          sessionId: sessionId,
        })
      );
    }
  }, [sessionId,headers]);



  useEffect(() => {
    if (refreshToken && headers?.["access-token"] !== refreshToken) {
      dispatch(
        setHeaders({
          ...headers,
          "access-token": refreshToken,
        })
      );
    } 
    // Commenting out as it was causing infinite loop in mobile hamburger menu
    // else if (!refreshToken && headers?.["access-token"]) {
    //   const tempHeader = {...headers};
    //   // delete tempHeader["access-token"];
    //   dispatch(
    //     setHeaders({
    //       ...tempHeader
    //     })
    //   );
    // }
  }, [refreshToken]);


  useEffect(() => {
    if(AddressQualificationSiteId && !headers?.siteId){
      if (
        (["QF_QUALIFIED", "QF QUALIFIED"]?.includes(
          brightSpeedFiberIndicator?.toUpperCase()
        ) && instantInternet) || AddressQualificationSiteId?.toLowerCase() === "qf-ii"
      ) {
        
        localStorage.setItem("headersSiteId","qf-ii");
        dispatch(
          setHeaders({
            ...headers,
            siteId: AddressQualificationSiteId || "qf-ii",
          })
        );
      }
    }
  }, [AddressQualificationSiteId]);

  const getBrightspeedTokenSync = async () => {
    await dispatch(getBrightspeedToken());
  };

  return headers;
}
